import Auth from "../../Auth";
import OppBriefClientProjectOverviewSection
	from "../../views/talent-opportunities/components/OppBriefClientProjectOverviewSection";
import OppBriefScopeSection from "../../views/talent-opportunities/components/OppBriefScopeSection";
import OppBriefTeamMembersSection from "../../views/talent-opportunities/components/OppBriefTeamMembersSection";
import OppBriefPayoutSection from "../../views/talent-opportunities/components/OppBriefPayoutSection";
import OppBriefRoleSkillsSection from "../../views/talent-opportunities/components/OppBriefRoleSkillsSection";
import OppBriefTimingSection from "../../views/talent-opportunities/components/OppBriefTimingSection";
import OppDashboard from "../../views/talent-opportunities/OppDashboard";
import OppBriefStep from "../../views/talent-opportunities/OppBriefStep";
import OppTeamStatusStep from "../../views/talent-opportunities/OppTeamStatusStep";
import OppContractStep from "../../views/talent-opportunities/OppContractStep";
import TalentPortal from "../../views/talent-portal/TalentPortal";
import Document from "../Document";
import Project from "../Project";
import User from "../User";
import ProjectPosition from "../ProjectPosition";

const OpportunityStatus = {
    Interested: 'Shown Interest',
    Invited: 'Invited',
    AwaitingTeamApproval: 'Awaiting Team Approval',
    Proposing: 'Proposing',
    PendingContract: 'Pending Contract',
    Active: 'Active',
    Lost: 'Lost',
    Declined: 'Declined',
    Complete: 'Complete',
    Withdrawn: 'Withdrawn',
    // Cancelled: 'Cancelled',
}

const IsOpportunityTraits = WrappedClass => {
    return class IsOpportunityTraits extends WrappedClass {

	    isForClientEngagementLead()
	    {
	        return this.is_for_client_engagement_lead;
	    }

	    isProposingAsIndividual()
	    {
	        return !this.is_for_team;
	    }

	    isProposingWithTeam()
	    {
	        return this.is_for_team;
	    }

        canGenerateCoverLetter() {
            return this.isProposingAsIndividual() && TB.isDefined(this.project_position?.proposal_generations_count) &&
                this.project_position?.proposal_generations_count < 3
        }

	    displayType() {
	        if (this.isProposingAsIndividual()) return 'Individual Project';
	        else if (this.isProposingWithTeam()) return 'Team Project'
	    }

	    static Statuses = OpportunityStatus;

	    static statusFlatLookup()
	    {
	        let lookup = laravel.talent_opportunity_statuses;
	        let statuses = []
	        for (let [value,label] of Object.entries(lookup)) {
	            statuses.push({label, value})
	        }
	        return statuses;
	    }

	    static statusOptions()
	    {
	        let options = TB.values({...OpportunityStatus});
	        let displayOptions = {};
	        for (let option of options) {
	            let displayOption = this.displayStatusFor(option)
	            displayOptions[displayOption] = true;
	        }

	        return TB.keys(displayOptions);
	    }

	    static getStatusTabs() {
	        let tabs = {
	            'invited': [
	                this.Statuses.Invited,
	                this.Statuses.AwaitingTeamApproval
	            ],
	            'interested': [
	                this.Statuses.Interested
	            ],
	            'proposing': [
	                this.Statuses.Proposing
	            ],
	            'sow': [
	                this.Statuses.PendingContract
	            ],
	            // 'active': [
	            //     this.Statuses.Active
	            // ],
	            // 'complete': [
	            //     this.Statuses.Complete
	            // ],
	            'active_complete': [
	                this.Statuses.Active,
	                this.Statuses.Complete
	            ],
	            'lost_declined': [
	                this.Statuses.Lost,
	                this.Statuses.Declined,
	                this.Statuses.Withdrawn,
	            ]
	        };

	        let statusTabs = {}
	        for (let [displayKey, statuses] of Object.entries(tabs)) {
	            let key = TB.trans(`talent.dashboard.opp_status_${displayKey}`);
	            statusTabs[key] = statuses;
	        }
	        return statusTabs;
	    }
	    static StatusTabs = TB.memoize(this.getStatusTabs.bind(this));

	    static displayStatusFor(oppStatus, opp)
	    {
	        for(let [display, statuses] of Object.entries(this.StatusTabs())) {
	            if (statuses.includes(oppStatus)) {
	                return display
	            }
	        }

	        let transKey = '';
	        switch (oppStatus) {
	            case OpportunityStatus.Interested:
	                transKey = 'interested';
	                break;
	            case OpportunityStatus.PendingLost:
	                if (opp) {
	                    if (opp.job_candidate?.talent_invited_at) {
	                        transKey = 'invited';
	                    }
	                    else if (opp?.project_position?.has_shown_interest_in_job && !opp.job_candidate?.talent_invited_at) {
	                        transKey = 'interested';
	                    }
	                }
	                transKey = 'invited';
	                break;
	            case OpportunityStatus.Invited:
	            case OpportunityStatus.AwaitingTeamApproval:
	                transKey = 'invited';
	                break;
	            case OpportunityStatus.Proposing:
	                transKey = 'proposing';
	                break;
	            case OpportunityStatus.PendingContract:
	                transKey = 'sow';
	                break;
	            case OpportunityStatus.Complete:
	            case OpportunityStatus.Active:
	                transKey = 'active_complete';
	                break;
	            // case OpportunityStatus.Complete:
	            //     transKey = 'complete';
	            //     break;
	            case OpportunityStatus.Withdrawn:
	            case OpportunityStatus.Lost:
	            case OpportunityStatus.Declined:
	                transKey = 'lost_declined';
	                break;
	            default:
	                return oppStatus;
	        }

	        if (!transKey) {
	            return oppStatus;
	        }

	        let fullKey = `talent.dashboard.opp_status_${transKey}`;


	        return TB.trans(fullKey);
	    }

	    displayStatus()
	    {
	        return this.constructor.displayStatusFor(this.status, this);
	    }

	    detailedViewAvailable() {
	        let invalidStatuses = [
	            // OpportunityStatus.Interested,
	            // OpportunityStatus.Active,
	            OpportunityStatus.Lost,
	            OpportunityStatus.Declined,
	            OpportunityStatus.Complete,
	            OpportunityStatus.Withdrawn,
	        ];

	        return !invalidStatuses.includes(this.status)
	    }


		/***********************************************************************
		 * Unseen Notifications/Highlights
		 ************************************************************************/

		lastUpdated() {

			let latestProjectUpdates = TB.values(
				TB.get(this, 'project.latest_updates') || {}
			);

			let latestUpdates = [
				// this.updated_at,
				...latestProjectUpdates
			];

			if (this.project_position) {
				let projectPositionUpdates = TB.get(this, 'project_position.latest_updates') || {};

				latestUpdates = [
					...latestUpdates,
					...TB.values(projectPositionUpdates)
				]
			}

			if (!latestUpdates.length) {
				return TB.moment().toISOString();
			}



			latestUpdates = TB.orderBy(latestUpdates, update => TB.moment(update).toDate(), 'desc');
			return TB.first(latestUpdates);
		}

		lastViewedAt() {
			return this.is_agency_opp ? this.last_viewed_at : this.job_candidate?.last_viewed_at
		}

		hasUnseenUpdate()
		{
			if (!this.isAvailable()) return false

			let steps = this.projectBriefSteps();
			for (let step of steps) {
				if (this.projectBriefHasUnseenUpdatesAtStep(step)) {
					return true;
				}
			}

			let lastClientActivity = TB.moment(this.project.latest_client_activity_at);
			let lastViewedActivity = TB.moment(this.lastViewedAt());

			if (!lastClientActivity.isValid()) {
				return false;
			}


			if (!lastViewedActivity.isValid()) {
				return true;
				// lastViewedActivity = TB.moment(this.created_at)
			}

			return lastViewedActivity.isSameOrBefore(lastClientActivity);
		}

		hasUnseenUpdateToRelated(relatedProp, relatedAttrs)
		{
			let last_viewed_at = this.lastViewedAt()
			if (!last_viewed_at) {
				return false;
			}

			let related = TB.get(this, relatedProp);
			if (!related || !related.latest_updates) {
				return;
			}

			if (!TB.isArray(relatedAttrs)) {
				relatedAttrs = [relatedAttrs];
			}

			let lastViewed = TB.moment(
				last_viewed_at
			);

			let updates = related.latest_updates;
			for (let relatedAttr of relatedAttrs) {
				if (!updates[relatedAttr]) {
					continue;
				}

				let hasUnseenUpdate = lastViewed.isBefore(
					updates[relatedAttr]
				);
				if (hasUnseenUpdate) {
					return true;
				}
			}

			return false;
		}

		hasUnseenUpdateToProjectClient() {
			return this.hasUnseenUpdateToRelated(
				'project', 'client'
			);
		}
		hasUnseenUpdateToProjectClientName() {
			return this.hasUnseenUpdateToRelated(
				'project.client', 'name'
			);
		}
		hasUnseenUpdateToProjectClientLogo() {
			return this.hasUnseenUpdateToRelated(
				'project.client', 'logo_path'
			);
		}
		hasUnseenUpdateToProjectClientIndustry() {
			return this.hasUnseenUpdateToRelated(
				'project.client', ['industry_id', 'industry']
			);
		}
		hasUnseenUpdateToProjectName() {
			return this.hasUnseenUpdateToRelated(
				'project', 'name'
			);
		}
		hasUnseenUpdateToProjectDescription() {
			return this.hasUnseenUpdateToRelated(
				'project', 'description'
			);
		}
		hasUnseenUpdateToProjectLocation() {
			return this.hasUnseenUpdateToRelated(
				'project', 'location'
			);
		}
		hasUnseenUpdateToProjectStartedAt() {
			return this.hasUnseenUpdateToRelated(
				'project', ['started_at', 'start_range']
			);
		}


		hasUnseenUpdateToProjectManagementTerms() {
			return this.hasUnseenUpdateToRelated(
				'project', ['is_managed']
			);
		}

		hasUnseenUpdateToProjectScopeQuestions() {
			return this.hasUnseenUpdateToRelated(
				'project', ['questions']
			);
		}
		hasUnseenUpdateToProjectScopeQuestion(question) {
			if (!this.hasUnseenUpdateToProjectScopeQuestions()) {
				return false;
			}

			let projectQuestions = this.project?.questions || [];

			let lastViewed = TB.moment(
				this.lastViewedAt()
			);

			for (let projectQuestion of projectQuestions)
			{
				if (question.id != projectQuestion.id) {
					continue;
				}

				let latestQuestionUpdate = TB.max(
					TB.values(projectQuestion.latest_updates)
				);
				return lastViewed.isBefore(
					latestQuestionUpdate
				);
			}

			return false;
		}

		hasUnseenUpdateToProjectPositionTitle() {
			return this.hasUnseenUpdateToRelated(
				'project_position', 'title'
			);
		}
		hasUnseenUpdateToProjectPositionDescription() {
			return this.hasUnseenUpdateToRelated(
				'project_position', 'description'
			);
		}
		hasUnseenUpdateToProjectPositionDescriptionPath() {
			return this.hasUnseenUpdateToRelated(
				'project_position', 'description_path'
			);
		}
		hasUnseenUpdateToProjectPositionIsContractToHire() {
			return this.hasUnseenUpdateToRelated(
				'project_position', 'is_contract_to_hire'
			);
		}
		hasUnseenUpdateToProjectPositionDiscipline() {
			return this.hasUnseenUpdateToRelated(
				'project_position', 'discipline_id'
			) || this.hasUnseenUpdateToRelated(
				'project_position.discipline', 'name'
			);
		}
		hasUnseenUpdateToProjectPositionDisciplineDescription() {
			return this.hasUnseenUpdateToRelated(
				'project_position', 'discipline_id'
			) || this.hasUnseenUpdateToRelated(
				'project_position.discipline', 'description'
			);
		}
		hasUnseenUpdateToProjectPositionMinScore() {
			return this.hasUnseenUpdateToRelated(
				'project_position', 'min_score'
			);
		}
		hasUnseenUpdateToProjectPositionSkills() {
			return this.hasUnseenUpdateToRelated(
				'project_position', 'skills'
			);
		}
		hasUnseenUpdateToProjectPositionIndustries() {
			return this.hasUnseenUpdateToRelated(
				'project_position', 'industries'
			);
		}

		hasUnseenUpdateToProjectPositionStartedAt() {
			return this.hasUnseenUpdateToRelated(
				'project_position', 'started_at'
			);
		}
		hasUnseenUpdateToProjectPositionEndedAt() {
			return this.hasUnseenUpdateToRelated(
				'project_position', 'ended_at'
			);
		}
		hasUnseenUpdateToProjectPositionAvgHoursPerWeek() {
			return this.hasUnseenUpdateToRelated(
				'project_position', 'avg_hours_per_period'
			);
		}
		hasUnseenUpdateToProjectPositionOnsiteRequirements() {
			return this.hasUnseenUpdateToRelated(
				'project_position', ['required_onsite', 'onsite_days_per_week']
			);
		}

		hasUnseenUpdateToProjectPositionTargetRate() {
			return this.project_position?.target_rate
				&& this.hasUnseenUpdateToRelated(
					'project_position', ['target_rate', 'target_rate_is_visible']
				);
		}

		projectBriefHasUnseenUpdatesAtStep(stepClass)
		{
			if (this.isService() || this.isForClientEngagementLead())
			{
				switch (stepClass)
				{
					case OppBriefClientProjectOverviewSection:
						return this.hasUnseenUpdateToRelated('project', [
							'name', 'description', 'location', 'client',
						]);
					// case OppBriefTermsSection: // doesn't apply to opp for Client Engagement Lead
					// 	return this.hasUnseenUpdateToRelated('project', [
					// 		'is_managed',
					// 	]);
					case OppBriefScopeSection:
						return this.hasUnseenUpdateToRelated('project', [
							'phases',
						]);
					// case OppBriefScheduleSection:
					// 	return this.hasUnseenUpdateToRelated('project', [
					// 		'started_at', 'start_range', 'ended_at',
					// 	]);
					case OppBriefTeamMembersSection: // doesn't apply to opp for Client Engagement Lead
					// case OppBriefDeliverablesSection:
					case OppBriefPayoutSection:
					default:
						return false;
				}
			}

			if (this.isBYO())
			{
				switch (stepClass)
				{
					case OppBriefClientProjectOverviewSection:
						return this.hasUnseenUpdateToRelated('project', [
							'name', 'description', 'location', 'client',
						]);
					case OppBriefRoleSkillsSection:
						return this.hasUnseenUpdateToRelated('project_position', [
							'title', 'description', 'description_path',
							'is_contract_to_hire',
							'discipline_id', 'discipline',
							'skills', 'industries', 'min_score',
						]);
					case OppBriefTimingSection:
						return this.hasUnseenUpdateToRelated('project_position', [
							'started_at', 'ended_at',
							'avg_hours_per_period',
							'required_onsite', 'onsite_days_per_week',
						]);
					case OppBriefPayoutSection:
						return this.hasUnseenUpdateToProjectPositionTargetRate();
					default:
						return false;
				}
			}
		}

		/***********************************************************************
		 * Accepting Opportunity Milestones
		 ************************************************************************/

		canEditProposal() {
			return !this.project.is_on_hold
				&& !this.isCompleted()
				&& !this.isActive() && !this.isRejected() && !this.isWithdrawn()
				&& !this.isPendingContract()
				// && (this.isProposingAsIndividual() || (this.isProposingWithTeam() && this.canAdmin()))
		}

		isAdmin() {
			if (TB.auth().user()?.isTalent?.() && TB.find(this.team?.members || [], ['id', TB.auth().user().id])) {
				let authMember = TB.find(this.team?.members || [], ['id', TB.auth().user().id]);

				return authMember.is_admin
			}
			return this.team?.is_admin
		}

		canAdmin() {
			return this.isAdmin() || TB.auth().user()?.canManageTalent()
		}

		canAcceptForTeam() {
			return this.job_candidate?.can_be_accepted_for_team
		}
		canRejectForTeam() {
			return this.job_candidate?.can_be_rejected_for_team
		}
		canWithdrawForTeam() {
			return this.job_candidate?.can_be_withdrawn_for_team
		}


		hasAcceptedTerms() {
			return !!this.job_candidate?.talent_accepted_at
		}

		hasAcceptedScope() {
			return !!this.accepted_scope_at
		}

		hasAcceptedSchedule() {
			return !!this.accepted_schedule_at
		}

		hasAcceptedTeam() {
			return !!this.accepted_team_at
		}

		hasAcceptedPayout() {
			return !!this.accepted_payout_at
		}

		hasAcceptedRoleSkillsAt() {
			return !!this.accepted_role_skills_at
		}

		hasAcceptedClientProjectOverview() {
			return !!this.accepted_client_project_overview_at
		}
		hasAcceptedDeliverables() {
			return !!this.accepted_deliverables_at
		}

		hasAcceptedBYOProjectBrief()
		{
			return this.hasAcceptedClientProjectOverview()
				&& this.hasAcceptedRoleSkillsAt()
				&& this.hasAcceptedSchedule()
			// && this.hasAcceptedPayout()
		}

		hasAcceptedServiceProjectClientEngagementLeadBrief()
		{
			return this.hasAcceptedClientProjectOverview()
				&& this.hasAcceptedTeam()
				&& this.hasAcceptedDeliverables()
			// && this.hasAcceptedPayout()
		}

		hasAcceptedServiceProjectBrief()
		{
			return this.hasAcceptedClientProjectOverview()
				&& this.hasAcceptedTeam()
				&& this.hasAcceptedDeliverables()
			// && this.hasAcceptedPayout()
		}

		hasAcceptedProjectBriefSections()
		{
			if (this.isBYO()) {
				return this.hasAcceptedBYOProjectBrief();
			}
			if (this.isForClientEngagementLead()) {
				return this.hasAcceptedServiceProjectClientEngagementLeadBrief();
			}
			if (this.isService()) {
				return this.hasAcceptedServiceProjectBrief();
			}

			return false
		}

		isAccepted() {
			if (this.isPendingContract()) {
				return true;
			}
			if (this.is_agency_opp) {
				return !this.withdrew_at && !this.rejected_at && this.accepted_at;
			}
			return (!this.rejected_at && !!this.accepted_at) || (!this.job_candidate?.talent_rejected_at && this.job_candidate?.talent_accepted_at)
		}

		projectBriefSteps()
		{
			if (this.isBYO()) {
				return [
					OppBriefClientProjectOverviewSection,
					OppBriefRoleSkillsSection,
					OppBriefTimingSection,
					// OppBriefPayoutSection
				]
			}

			if (this.isForClientEngagementLead()) {
				return [
					OppBriefClientProjectOverviewSection,
					OppBriefTeamMembersSection,
					// OppBriefTermsSection,
					OppBriefScopeSection,
					// OppBriefDeliverablesSection,
					// OppBriefScheduleSection,
					// OppBriefPayoutSection
				];
			}

			if (this.isService()) {
				return [
					OppBriefClientProjectOverviewSection,
					OppBriefTeamMembersSection,
					// OppBriefTermsSection,
					OppBriefScopeSection,
					// OppBriefDeliverablesSection,
					// OppBriefScheduleSection,
					// OppBriefPayoutSection
				];
			}

			return [];
		}

		briefTab(step) {
			switch (step) {
				case OppBriefClientProjectOverviewSection:
					return 'Client and Project Overview';
				case OppBriefTeamMembersSection:
					return 'Team Members';
				// case OppBriefTermsSection:
				// 	return 'Project Management';
				case OppBriefScopeSection:
					return 'Project Scope';
				// case OppBriefDeliverablesSection:
				// 	return 'Deliverables';
				// case OppBriefScheduleSection:
				// 	return 'High-Level Schedule';
				case OppBriefPayoutSection:
					return 'Estimated Fee';
				case OppBriefRoleSkillsSection:
					return 'Role Overview';
				case OppBriefTimingSection:
					return 'Project Timing';
			}
		}

		briefHeader(step) {
			switch (step) {
				default:

				case OppBriefClientProjectOverviewSection:
				case OppBriefTeamMembersSection:
				// case OppBriefTermsSection:
				case OppBriefScopeSection:
				// case OppBriefDeliverablesSection:
				// case OppBriefScheduleSection:
				case OppBriefRoleSkillsSection:
				case OppBriefTimingSection:
				case OppBriefPayoutSection:
					return this.briefTab(step);
			}
		}

		briefDescription(step) {
			switch (step) {
				case OppBriefClientProjectOverviewSection:
					return false;
				case OppBriefTeamMembersSection:
					return 'Names and roles on project team';
				case OppBriefScopeSection:
				// 	if(this.project?.hasAnsweredQuestions?.()) {
				// 		return 'The following answers were provided by our client for key areas affecting the project scope.';
				// 	}else {
				// 		return 'The following questions & answers reflect a base-line or entry level set of assumptions for project scope.';
				// 	}
				// case OppBriefDeliverablesSection:
					return 'Typical deliverables and activities for this type of project';
				// case OppBriefTermsSection:
				// 	return 'Client specific project management approach';
				// case OppBriefScheduleSection:
				// 	return false;
				// case OppBriefRoleSkillsSection:
				// 	return 'Role definition and client provided skill requirements';
				// case OppBriefTimingSection:
				// 	return 'Estimated project timing specified by client';
				case OppBriefPayoutSection:

					if (this.isBYO()) {
						return 'The hourly rate below is from your profile for this role. ' +
							'Estimated project hours and duration were specified by the client. ' +
							'If you decide to pursue this opportunity, clients are often open to ' +
							'refining project specifics including start date, end date and expected hours.'
					}else return false
			}
		}

		currentBriefStepNeeded()
		{
			if (this.isBYO())
			{
				if (!this.hasAcceptedClientProjectOverview()) {
					return OppBriefClientProjectOverviewSection
				}
				if (!this.hasAcceptedRoleSkillsAt()) {
					return OppBriefRoleSkillsSection
				}
				if (!this.hasAcceptedSchedule()) {
					return OppBriefTimingSection
				}
				// if (!this.hasAcceptedPayout()) {
				//     return OppBriefPayoutSection;
				// }

				return OppBriefClientProjectOverviewSection;
			}

			if (this.isService())
			{
				if (!this.hasAcceptedClientProjectOverview()) {
					return OppBriefClientProjectOverviewSection
				}
				if (!this.hasAcceptedTeam()) {
					return OppBriefTeamMembersSection;
				}
				// if (!this.hasAcceptedTerms()) {
				// 	return OppBriefTermsSection;
				// }
				if (!this.hasAcceptedScope()) {
					return OppBriefScopeSection;
				}
				// if (!this.hasAcceptedDeliverables()) {
				// 	return OppBriefDeliverablesSection;
				// }
				// if (!this.hasAcceptedSchedule()) {
				// 	return OppBriefScheduleSection;
				// }
				// if (!this.hasAcceptedPayout()) {
				//     return OppBriefPayoutSection;
				// }

				return OppBriefClientProjectOverviewSection;
			}
		}

		/***********************************************************************
		 * Current Opportunity Step Helpers
		 ************************************************************************/

		pendingContract()
		{
			return this.isPendingContract()
		}


		hasSignedContract() {
			return this.isActive()
		}

		talentSteps()
		{
			let steps = [
				{
					shortName: "Invited",
					name: 'Review Project Brief',
					isComplete: this.isAccepted(),
					isActive: !this.isInterested() && !this.isAccepted(),
				}
			];


			// if (this.isService() && !this.isForClientEngagementLead()) {
			// 	steps.push({
			// 		shortName: "Team Approval",
			// 		name: this.isAdmin() ? 'Manage Team Pursuit Interest' : 'View Team Pursuit Status',
			// 		isComplete: this.isProposing() || this.isPendingContract() || this.hasSignedContract(),
			// 		isActive: this.isAccepted() && this.isAwaitingTeamApproval()
			// 	})
			// }

			steps = [
				...steps,
				{
					shortName: "Pursuing",
					name: this.job_candidate?.talent_proposed_at ? 'Update Proposal' : 'Create Proposal',
					isComplete: this.isPendingContract() || this.hasSignedContract(),
					isActive: this.isAccepted() && this.isProposing(),
				},
				{
					shortName: "Selected",
					name: 'Sign Contract',
					isComplete: this.hasSignedContract(),
					isActive: this.isAccepted() && this.isPendingContract(),
				}
			]

			return steps;
		}

		currentProjectStep()
		{
			let user = Auth.registeredTalentUser();
			if (user && user.isTalentSupplierResource()) {
				return OppDashboard
			}

			if (this.isInterested()) {
				return OppDashboard
			}
			if (this.isInvited()) {
				return OppBriefStep
			}
			if (this.isAwaitingTeamApproval()) {
				return OppTeamStatusStep
			}
			if (this.isProposing()) {
				return OppDashboard
			}
			if (this.isPendingContract()) {
				return OppContractStep
			}

			return OppBriefStep
		}

		hasSubmittedProposal() {
			if (this.isProposingWithTeam()) {
				return this.isAccepted() || this.isRejected() || this.isWithdrawn()
			}
			return !!this.job_candidate?.talent_proposed_at
		}

		hasTimeline()
		{
			let startDate = this.startDate();
			return startDate !== false
		}

		hasTimelineRange()
		{
			let endDate = this.endDate();

			return this.hasTimeline() && endDate !== false
		}

		startDate() {
			let startDate = false;

			if (this.project_position?.started_at) {
				startDate = TB.moment(this.project_position?.started_at).clone();
			}
			else if (this.project.anticipatedStart() !== false){
				startDate = TB.moment(this.project.anticipatedStart()).clone();
			}

			return startDate
		}
		endDate() {
			let endDate = false;

			if (this.project_position?.ended_at) {
				endDate = TB.moment(this.project_position?.ended_at).clone();
			}else if (this.project.anticipatedEnd() !== false){
				endDate = TB.moment(this.project.anticipatedEnd()).clone();
			}

			return endDate
		}


		panelTimeDisplay(shortened = false)
		{
			let start = this.startDate(),
				end = this.endDate();

			if (this.confirmedStartedAt() && this.confirmedEndedAt()) {
				start = TB.moment(this.job_candidate?.confirmed_started_at),
					end = TB.moment(this.job_candidate?.confirmed_ended_at);
			}

			if (!start || !end) {
				return '---';
			}

			if (shortened) {
				return TB.shortTimeRange(start, end);
			}

			return start.format("ll")  + " - " +  end.format("ll")
		}

		oppListWithSimilarStatus() {
			return TalentPortal.projectsListPath(this.displayStatus())
		}

		contactAgencyConsultant()
		{
			if (window.Intercom) {
				window.Intercom(
					'showNewMessage',
					`Hello. I have a question about my project opportunity: ${this.project.name}`
				);
			}else alert("Thank you. Your agency consultant will reach out to you soon")
		}


		talentUser()
		{
			if (!this.talent_user) {
				return;
			}

			return this.talent_user;
		}

		hasContract()
		{
			let doc = this.latestContract();

			return TB.isObject(doc);
		}

		latestContract()
		{
			if (!this.latest_contract || !TB.isString(this.latest_contract.path)) {
				return;
			}

			return Document.make({...this.latest_contract});
		}

		latestSignedContract()
		{
			if (!this.latest_signed_contract || !TB.isString(this.latest_signed_contract.path)) {
				return;
			}

			return Document.make({...this.latest_signed_contract});
		}

		estimatedFee(shorten = true) {
			if (this.job_candidate?.premarkup_cost) {
				return TB.formatCurrency(this.job_candidate?.premarkup_cost, shorten);
			}

			if (this.job_candidate?.premarkup_standard_cost) {
				return TB.formatCurrency(this.job_candidate?.premarkup_standard_cost, shorten);
			}

			if (this.relatedJob()?.payout_amount) {
				return TB.formatCurrency(this.relatedJob()?.payout_amount, shorten);
			}

			return '---'
		}
		estimatedHourlyRate() {
			return this.job_candidate?.hourly_rate
		}

		static isServiceType(typeName)
		{
			return typeName === ProjectType.Service;
		}

		isService()
		{
			return Project.isServiceType(
				this.project.typeName()
			)
		}

		teamMembers() {
			if (!this.team?.members?.length) {
				return [];
			}
			let talent_opps = this.job_candidate?.talent_opps || [];

			return TB.uniqBy(this.team?.members, 'id').map(user => {
				let title = '';
				if (user.disciplines?.length){
					user.disciplines.map(({name}, index) => {
						title += name;
						if (index !== (user.disciplines.length - 1)) {
							title += ', '
						}
					})
				}
				let related_opp = TB.find(talent_opps, ['user.id', user.id]);

				return User.make({...user,talent_opp_id: related_opp?.id, title})
			})
		}

		isBYO()
		{
			return Project.isBYOType(
				this.project.typeName()
			)
		}

		isFixedFee() {
			return this.is_fixed_fee_contract || this.project_position?.isFixedFee?.()
		}

		isFixedRetainer() {
			return this.is_fixed_retainer_contract || this.project_position?.isFixedRetainer?.()
		}

		isTimeMaterials() {
			return (!this.is_fixed_fee_contract && !this.is_fixed_retainer_contract) || this.project_position?.isTimeMaterials?.()
		}
		platformDiscipline() {
			if (!this.talent_discipline || !TB.isDefined(laravel.discipline_categories)){
				return false
			}

			return TB.find(
				TB.flatten(
					TB.map([...laravel.discipline_categories], 'disciplines')
				),
				['id', this.talent_discipline.id]
			)
		}

		profileDisciplineForTalent(talent) {
			if (!talent?.talent_disciplines){
				return false
			}

			return TB.find(
				talent.talent_disciplines || [],
				['id', this.talent_discipline.id]
			)
		}

		hasClientTargetRate() {
			return this.project_position?.target_rate
		}

		differenceFromRequestedHourlyRate() {
			let hourly_rate = this.project_position?.market_rate;

			if(this.hasClientTargetRate()) {
				hourly_rate = this.project_position?.target_rate
			}

			return Number(parseFloat(this.job_candidate?.hourly_rate) - parseFloat(hourly_rate)).toFixed(0)
		}

		displayName() {
			let name = '';
			if (this.isBYO()) {
				name = this.project_position.title
			}
			if (this.isService()) {

				if (this.isForClientEngagementLead()) {
					name = 'Engagement Manager';
				}
				name = this.project.service?.name;
			}
			return TB.truncate(name, {
				length: 100
			})
		}

		relatedJob() {
			if(!this.project_position) {
				return null;
			}
			return  ProjectPosition.make({
				...this.project_position,
				matching: this.matching || this.project_position.matching,
                listing_status: this.project_position.listing_status || 'Accepting Proposals',
				metrics: this.metrics || this.project_position.metrics,
				payout_amount: this.estimated_payout_amount || this.project_position.estimated_payout || this.project_position.payout_amount,
				has_shown_interest_in_job: true,
				is_match: true,
				related_opportunity_id: this.id,
				project: this.project,
				client: this.client
			});
		}

		requestedDate = TB.memoize(this.requestedStartDate.bind(this));
		minDate = TB.memoize(this.minStartDate.bind(this));
		maxDate = TB.memoize(this.maxStartDate.bind(this));

		requestedStartDate() {
			return TB.moment(this.project_position.started_at).toDate()
		}

		minStartDate() {
			if (!this.project_position?.started_at) {
				return null
			}
			let start = TB.moment(this.project_position.started_at)

			return start.subtract(1, 'weeks').startOf('day').toDate();
		}

		maxStartDate() {
			if (!this.project_position?.started_at) {
				return null
			}
			let start = TB.moment(this.project_position.started_at)

			return start.add('weeks',1).toDate();
		}

		experienceLevel() {
			let level = laravel.talent_experience_levels[this.project_position?.min_score];
			if(!level) level = TB.first(TB.values(laravel.talent_experience_levels));

			return level?.level
		}
		experienceLabel() {
			let level = laravel.talent_experience_levels[this.project_position?.min_score];
			if(!level) level = TB.first(TB.values(laravel.talent_experience_levels));

			return level?.label
		}

		hourlyRate(formatted = true)
		{
			let rate = this.job_candidate?.hourly_rate;

			if (!formatted) {
				return rate;
			}

			return TB.formatCurrency(
				rate
			);
		}

		confirmedStartedAt()
		{
			if (!this.job_candidate?.confirmed_started_at || !TB.moment(this.job_candidate?.confirmed_started_at).isValid()) {
				return false
			}

			return TB.moment(this.job_candidate?.confirmed_started_at).format('MM/DD/YYYY');
		}
		confirmedEndedAt()
		{
			if (!this.job_candidate?.confirmed_ended_at || !TB.moment(this.job_candidate?.confirmed_ended_at).isValid()) {
				return false
			}

			return TB.moment(this.job_candidate?.confirmed_ended_at).format('MM/DD/YYYY');
		}

		confirmedAvailableHoursPerWeek()
		{
			if (!this.job_candidate?.confirmed_avg_hours_per_period && !parseInt(this.job_candidate?.confirmed_avg_hours_per_period)) {
				return false
			}

			return `Confirmed ${this.job_candidate?.confirmed_avg_hours_per_period} Hours Per Week`;
		}
		/***********************************************************************
		 * Status Helpers
		 ************************************************************************/

		progressSteps() {
			let steps = this.talentSteps();

			if (this.relatedJob()?.has_shown_interest_in_job) {
				steps.push({
					shortName: "Active",
					isComplete: this.isActive()
				})
				steps.unshift({
					shortName: "Interested",
					isComplete: true,
					isActive: this.isInterested(),
				})
			}

			return steps;
		}

		getCurrentProgress() {
			let steps = this.progressSteps();

			let index = TB.findLastIndex(steps, ['isActive', true]) + 1;
			return index / steps.length * 100
		}
		isInterested() {
			return this.status === OpportunityStatus.Interested;
		}
		isInvited() {
			return this.status === OpportunityStatus.Invited;
		}
		isAwaitingTeamApproval() {
			return this.status === OpportunityStatus.AwaitingTeamApproval;
		}
		isActive() {
			return this.status === OpportunityStatus.Active;
		}
		isCompleted() {
			return this.status === OpportunityStatus.Complete;
		}

		isProposing() {
			return this.isInterested() || this.isInvited() ||
				this.status === OpportunityStatus.Proposing;
		}

		isPendingContract() {
			return this.status === OpportunityStatus.PendingContract;
		}

		isWithdrawn() {
			return this.withdrew_at
				|| this.status === OpportunityStatus.Withdrawn;
		}

		isLost() {
			return this.status === OpportunityStatus.Lost;
		}

		isRejected() {
			return this.rejected_at
				|| this.status === OpportunityStatus.Declined;
		}

		isAvailable() {
			return !this.isRejected()
				&& !this.isWithdrawn()
				&& !this.isLost()
		}

		canMessageAndAcceptInterviews() {

			return !!this.id && !this.isOnHold()
				&& !this.isInterested()
				&& !this.isRejected()
				&& !this.isWithdrawn()
				&& !this.isLost()
		}

		isOnHold() {
			return this.project.is_on_hold
		}
    }
}


export default IsOpportunityTraits